import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';

const SmallSelect = ({ select = true, ref, ...rest }) => {
  const [value, setValue] = useState(null);
  const handleChange = event => {
    setValue(event.target.value);
  };

  return (
    <TextField
      p={20}
      ref={ref}
      select={select}
      fullWidth
      margin="normal"
      size="small"
      variant="outlined"
      onChange={handleChange}
      value={value}
      {...rest}
    />
  );
};

const MySmallSelect = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#fa6446'
      }
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: '#fa6446'
      }
    }
  }
})(SmallSelect);

export default MySmallSelect;
